export default __webpack_public_path__ + "static/media/a023-example1.94f16b5b.png";